/** Incremental SSE framing; chunks can split UTF-8 characters, lines and JSON. */
export async function readFeedbackEvents(response, onEvent, signal) {
  if (!response.ok || !response.body) {
    const error = new Error('Live feedback could not be connected.');
    error.status = response.status;
    throw error;
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let pending = '';
  const emit = frame => {
    let event = 'message';
    const data = [];
    frame.split('\n').forEach(line => {
      if (line.startsWith('event:')) event = line.slice(6).trim();
      if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
    });
    if (data.length && !signal?.aborted) onEvent(event, JSON.parse(data.join('\n')));
  };
  try {
    while (!signal?.aborted) {
      const { done, value } = await reader.read();
      pending += decoder.decode(value, { stream: !done }).replace(/\r/g, '');
      if (pending.length > 1_000_000) throw new Error('Live feedback event exceeded its limit.');
      let boundary;
      while ((boundary = pending.indexOf('\n\n')) >= 0) {
        emit(pending.slice(0, boundary));
        pending = pending.slice(boundary + 2);
      }
      if (done) break;
    }
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
